'use strict';

/**
 * IE 11 has spotty classList support, especially for svg elements. classList
 * is used by our date pickers via the `react-onclickoutside` package. As long
 * as we are supporting IE 11, we need this.
 */

if (typeof SVGElement !== 'undefined' && !('classList' in SVGElement.prototype)) {
  Object.defineProperty(SVGElement.prototype, 'classList', {
    get: function get() {
      var _this = this;

      return {
        contains: function contains(className) {
          return _this.className.baseVal.split(' ').indexOf(className) !== -1;
        }
      };
    }
  });
}